import { useContext } from "react";
import { SettingsContext, type SettingsContextValue } from "../contexts/settings-context";

export const useSettings = (): SettingsContextValue => useContext(SettingsContext);
